import type { ReactNode, Ref } from 'react'

interface LinkProps {
  ref?: Ref<HTMLAnchorElement>
  href: string
  children?: ReactNode
  openInNewTab?: boolean
  className?: string
}

export function Link({
  ref,
  href,
  children,
  openInNewTab = true,
  className,
}: LinkProps) {
  return (
    <a
      ref={ref}
      href={href}
      target={openInNewTab ? '_blank' : undefined}
      rel={openInNewTab ? 'noopener noreferrer' : undefined}
      className={className}
    >
      {children}
    </a>
  )
}
